import { render, staticRenderFns } from "./DictionariesSettingsList.vue?vue&type=template&id=5e5cfe78&scoped=true&"
import script from "./DictionariesSettingsList.vue?vue&type=script&lang=js&"
export * from "./DictionariesSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesSettingsList.vue?vue&type=style&index=0&id=5e5cfe78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5cfe78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRow})
